import { FC } from 'react';
import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { PricingFilters } from '../../types/pricing';

interface PricingRulesFiltersProps {
  search: string;
  onSearchChange: (search: string) => void;
  filters: PricingFilters;
  onFiltersChange: (filters: PricingFilters) => void;
  pageSize: number;
  onPageSizeChange: (pageSize: number) => void;
}

export const PricingRulesFilters: FC<PricingRulesFiltersProps> = ({
  search,
  onSearchChange,
  filters,
  onFiltersChange,
  pageSize,
  onPageSizeChange,
}) => {
  return (
    <div className="flex flex-col sm:flex-row gap-4">
      <Input
        placeholder="Search rules by name or configuration type..."
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        className="flex-1"
      />

      <Select
        value={filters.ruleType}
        onValueChange={(value) => onFiltersChange({ ...filters, ruleType: value })}
      >
        <SelectTrigger className="w-48">
          <SelectValue placeholder="Filter by type" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Types</SelectItem>
          <SelectItem value="CONTAINER_MATERIAL_MATRIX">Single Material</SelectItem>
          <SelectItem value="CONTAINER_PERIOD_PRICING">Flat Rate</SelectItem>
          <SelectItem value="TONNAGE_PRICING">Tonnage Pricing</SelectItem>
          <SelectItem value="AUTO_DISCOUNT">Auto Discount</SelectItem>
          <SelectItem value="DISCOUNT">Discount</SelectItem>
        </SelectContent>
      </Select>

      <Select
        value={filters.status}
        onValueChange={(value) => onFiltersChange({ ...filters, status: value })}
      >
        <SelectTrigger className="w-32">
          <SelectValue placeholder="Status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All</SelectItem>
          <SelectItem value="active">Active</SelectItem>
          <SelectItem value="inactive">Inactive</SelectItem>
        </SelectContent>
      </Select>

      <Select
        value={pageSize.toString()}
        onValueChange={(value) => onPageSizeChange(parseInt(value, 10))}
      >
        <SelectTrigger className="w-24">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="10">10</SelectItem>
          <SelectItem value="25">25</SelectItem>
          <SelectItem value="50">50</SelectItem>
          <SelectItem value="100">100</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
